import { useState, useEffect } from "react";
import util from "../utils/Helpers";

function CSRF(props) {
  const [dataIsReturned, setDataIsReturned] = useState(false);

  useEffect(() => {
    const apiRoot = util.buildFullUrl(`/auth`);
    const fetchCSRF = () => {
      fetch(`${apiRoot}/csrf`, {
        credentials: "include",
        headers: {
          "Content-Type": "application/json",
        },
      })
        .then((response) => response.json())
        .then((data) => {
          if (!data["CSRF-Token"]) {
            window.location.href = `${apiRoot}/logout?action=csrf-logout-expired`;
          }
          window["CSRF-Token"] = data["CSRF-Token"];
          setDataIsReturned(true);
        })
        .catch(() => {
          setDataIsReturned(true);
        });
    };
    fetchCSRF();
  }, []);

  return dataIsReturned ? props.children : null;
}
export default CSRF;
